import { Outlet } from 'react-router-dom';

// project imports
import Customization from '../Customization';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
    <>
        <Outlet />
        {/* importar ruedita de pantalla pricinpal */}
        {/* <Customization /> */}
    </>
);

export default MinimalLayout;
